/* eslint-disable react/jsx-key */
import React from "react";
import { Column } from "react-table";

import { Session} from "types";
import { Text } from "@chakra-ui/react";
import LazyDataTable from "components/LazyDataTable";
import { SelectFilter } from "components/LazyFilters";
import AppointmentRow from "./AppointmentRow";
import { useUser } from "context/user";
import { startCase } from "lodash";
import { GetClientFirstNameList, GetClientLastNameList, GetClientUserNameList, GetCommaSeperatedClientList } from "utils/user";
import { useQuery, QueryKey } from "@tanstack/react-query";
import { queryKeys, queryFns } from "repo/sessions";
import { FetchDataProps } from "types/datacontext";

interface Props {
  dataKey: QueryKey | ((props: FetchDataProps) => QueryKey);
}

const AppointmentsDataTable: React.FC<Props> = ({dataKey}: Props) => {
  const { user: actor } = useUser()!;
  const { isLoading, error, data } = useQuery({
    queryKey: queryKeys.filters(false),
    queryFn: queryFns.filters,
    placeholderData: {}
  });

  //function getFilterValues(key: string) {
  //  if (isLoading || error || !data || data[key]) return [];
  //  return data[key];
  //}

  const columns: Column<Session>[] = React.useMemo(() =>
    [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => (
          <AppointmentRow session={original}  />
        )
      },
      {
        Header: "Title",
        accessor: "title",
        disableSortBy: true
      },
      {
        Header: "Date",
        accessor: "start_time"
      },
      {
        Header: "Status",
        id: "status",
        accessor: row => startCase(row.status),
        disableSortBy: true,
        Filter: SelectFilter(data ? data['status'] : []),
        filter: "equals"
      },
      {
        Header: "Client(s) Username",
        id: "client_username",
        accessor: row => GetClientUserNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Client(s) First",
        id: "client_first_name",
        accessor: row => GetClientFirstNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Client(s) Last",
        id: "client_last_name",
        accessor: row => GetClientLastNameList(row.participants, row.coach),
        disableSortBy: true
      },
      {
        Header: "Client(s)",
        id: "client_name",
        accessor: row => GetCommaSeperatedClientList(row.participants, row.coach),
        disableSortBy: true,
        Filter: SelectFilter(data? data['client_name'] : []),
        filter: "equals"
      }
    ], [data]);

  return ((isLoading || error) ?
    <Text> Loading...</Text> :
    <LazyDataTable columns={columns} dataKey={dataKey} dataFn={queryFns.data} tableTitle="" />
  );
};

export default AppointmentsDataTable;
